import React from "react";
import { TextField, InputAdornment, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

function SearchBar({ disabled, placeholder, onChange, value, onClear }) {
  return (
    <Box sx={{ width: "100%" }}>
      <TextField
        fullWidth
        placeholder={placeholder || "Search..."}
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
        size="small"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            backgroundColor: "#F8FAFC",
            "& fieldset": {
              borderColor: "#E2E8F0",
            },
            "&:hover fieldset": {
              borderColor: "#94A3B8",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#2469F0",
              borderWidth: 2,
            },
          },
          "& .MuiInputBase-input": {
            fontSize: "0.85rem",
            py: 1,
            "&::placeholder": {
              color: "#94A3B8",
              opacity: 1,
            },
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#94A3B8", fontSize: 20 }} />
            </InputAdornment>
          ),
          endAdornment: value && (
            <InputAdornment position="end">
              <Box
                onClick={onClear || (() => onChange({ target: { value: "" } }))}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  bgcolor: "#F1F5F9",
                  color: "#94A3B8",
                  "&:hover": {
                    bgcolor: "#E2E8F0",
                    color: "#475467",
                  },
                  transition: "all 0.2s ease",
                }}
              >
                <CloseIcon sx={{ fontSize: 14 }} />
              </Box>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}

export default SearchBar;